import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table
} from 'reactstrap'


class EditTVModal extends PureComponent {
    
    constructor(props) {
        super(props);
        this.onEditClick = this.onEditClick.bind(this);
    }

    
    onEditClick(tv) {
        return e => {
            e.stopPropagation();
            this.props.onEditTV(tv)
        };
    }

    renderResults() {
        return this.props.tvList.map(tv => (
        <tr
            key={tv.id}
            className="user-table__item"
        >
            <td className="text-center">
                {tv.otherOptions.TVName ? tv.otherOptions.TVName : <i>No Name</i>}
            </td>
            <td className="text-center">
                {tv.id}
            </td>
            <td className="text-center">
                <Button
                onClick={this.onEditClick(tv)}
                color="success"
                >
                Edit this TV
                </Button>
            </td>
        </tr>
        ));
    }


    render() {
        return (
            
        <Modal
            isOpen={this.props.open}
            toggle={this.toggle}
            className={this.props.className}
        >
            {this.props.open ? (
            <div>
                <ModalHeader toggle={this.props.close}>Edit a TV for {this.props.selectedBusiness.name}</ModalHeader>
                <ModalBody>
                {this.props.tvList.length ? (
                        <Table
                        hover
                        responsive
                        className="table-outline mb-0 d-none d-sm-table user-table"
                        >
                        <thead className="thead-light">
                            <tr>
                            <th className="text-center">Name</th>
                            <th className="text-center">TV ID</th>
                            <th className="text-center">Edit</th>
                            </tr>

                            {this.renderResults()}
                        </thead>
                        <tbody />
                        </Table>
                    ) : <div>This business has no GoNation TVs.</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={this.props.onClose}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </div>
            ): null}
        </Modal>
        
        )
    }
}
export default EditTVModal;


// WEBPACK FOOTER //
// ./src/views/Components/Modals/EditTVModal.js